import cashapp_deposit from './cashapp_deposit';
import chime_deposit from './chime_deposit';
import cashapp_merchant_deposit from './cashapp_merchant_deposit';
import applepay_merchant_deposit from './applepay_merchant_deposit';
import googlepay_merchant_deposit from './googlepay_merchant_deposit';
import cashapp_p2p_rent from './cashapp_p2p_rent';

export default {
    cashapp_deposit,
    chime_deposit,
    cashapp_merchant_deposit,
    applepay_merchant_deposit,
    googlepay_merchant_deposit,
    cashapp_p2p_rent
}